import React, { memo } from 'react';
import { FieldTitle } from "./style";
var Field = function Field(_ref) {
  var title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FieldTitle, null, title), /*#__PURE__*/React.createElement("div", null, children));
};
export default /*#__PURE__*/memo(Field);